// Deployment environment, set per Cloudflare Pages build via
// NEXT_PUBLIC_ENVIRONMENT. Unset locally, where it resolves to "local".
export type AppEnvironment = "local" | "development" | "integration" | "production"

const KNOWN_ENVIRONMENTS: readonly AppEnvironment[] = [
  "local",
  "development",
  "integration",
  "production",
]

export function getAppEnvironment(): AppEnvironment {
  const raw = process.env.NEXT_PUBLIC_ENVIRONMENT
  return KNOWN_ENVIRONMENTS.includes(raw as AppEnvironment) ? (raw as AppEnvironment) : "local"
}

export function isDeployedEnvironment(): boolean {
  return getAppEnvironment() !== "local"
}
